import { API_CONTENT_TYPE, API_ACCEPT } from "shared/constants";

export const getHeaders = (
  contentType: keyof typeof API_CONTENT_TYPE = "JSON",
  accept: keyof typeof API_ACCEPT = "JSON_API"
) => {
  return {
    "content-type": API_CONTENT_TYPE[contentType],
    accept: API_ACCEPT[accept],
  };
};
